import { useLoaderData } from 'react-router';
import { InvoiceList } from '../../../../../components/InvoiceList/InvoiceList.js';
import { Invoices, InvoicesSceneTab } from '../../../../../components/Invoices/Invoices.js';
import { SupportCaseNotification } from '../../../../../components/SupportCaseNotification/SupportCaseNotification.js';
import type { InvoicesLoaderData } from '../../../../../common/loaders.js';

export const InvoicesPath = () => {
  const { invoices, supportCases } = useLoaderData() as InvoicesLoaderData;

  return (
    <Invoices tab={InvoicesSceneTab.INVOICES}>
      <SupportCaseNotification openSupportCases={supportCases?.searchResults?.map(r => r.result)} />
      <InvoiceList invoices={invoices.searchResults} total={invoices.total} />
    </Invoices>
  );
};
